import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { animated, useSpring } from 'react-spring';
import { handleOpenMenu, menuSelector } from '../../entities/ComponentsSlice';
import { deviceSelector } from '../../entities/UserSlice';
import AnimateLines from '../../features/animate-lines/AnimateLines';
import ButtonClose from '../../features/button-close/ButtonClose';
import HeaderButtons from '../../features/header-buttons/HeaderButtons';
import HeaderLogo from '../../features/header-logo/HeaderLogo';
import ModalMenuRoutes from '../../shared/modal-menu-routes/ModalMenuRoutes';
import style from './ModalMenu.module.scss';

const ModalMenu = () => {
  const [toggle, setToggle] = useState(true);
  const [reverse, setReverse] = useState(false);
  const formRef = useRef();
  const contacts = useSelector(state => state.projectinfo.contacts);

  const device = useSelector(deviceSelector);
  const openModelForm = useSelector(menuSelector);
  const dispatch = useDispatch();

  const opacityStyle = useSpring({
    config: { duration: 600 },
    opacity: toggle ? 0 : 1,
    x: toggle ? -1000 : 0,
    delay: 0,
    loop: false,
  });

  useEffect(() => {
    if (openModelForm) {
      setTimeout(() => {
        setToggle(false);
      }, 0);
      setTimeout(() => {
        setReverse(true);
      }, 200);
    } else {
      setReverse(false);
    }
  }, [openModelForm, reverse]);

  const handleCloseFormModel = () => {
    setToggle(true);
    setTimeout(() => {
      dispatch(handleOpenMenu(false));
    }, 500);
  };

  const handleKeyPress = event => {
    if (event.key === 'Escape') {
      handleCloseFormModel();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', event => {
      handleKeyPress(event);
    });
    return () =>
      document.removeEventListener('keydown', event => {
        handleKeyPress(event);
      });
  }, [handleKeyPress]);

  useEffect(() => {
    if (openModelForm) disableBodyScroll(document.body);
    if (!openModelForm) enableBodyScroll(document.body);
  }, [openModelForm]);

  return (
    <>
      {openModelForm && (
        <div className={style.formModal}>
          <div onClick={() => handleCloseFormModel()} className={style.formModalBack} role='button' tabIndex='0' />
          <animated.div style={opacityStyle} className={style.formModalContainer} ref={formRef}>
            <div className={style.formModal__box}>
              <div className={style.formModal__top}>
                <div className={style.formModal__routes__btn}>
                  <div className={style.formModal__route__btn}>
                    <HeaderLogo
                      color='black'
                      handleScrollTop={() => handleCloseFormModel()}
                      openModelForm={openModelForm}
                    />
                    <HeaderButtons toggleWhite={true} headerColorScheme='' />
                  </div>
                </div>
                <ButtonClose
                  id='close_black'
                  className={style.formModalBtnClose}
                  handleFuction={handleCloseFormModel}
                />
              </div>
            </div>
            <div className={style.scrollableContent}>
              <ModalMenuRoutes />
              <div className={style.formModal__links}>
                <a className={style.formModal__link} href={'mailto:' + contacts.mail}>
                  {contacts.mail}
                </a>
                <a className={style.formModal__link} href={'tel:' + contacts.phone}>
                  {contacts.phone}
                </a>
              </div>
            </div>
            <div className={style.gradient} />

            {device !== 'isMobile' && (
              <AnimateLines id='vector_9' className={style.formModal__svgClass} toggle={reverse} />
            )}
          </animated.div>
        </div>
      )}
    </>
  );
};

export default ModalMenu;
